import { useContext, useState } from 'react';
import DirectoryInput from 'components/DirectoryInput';
import { List, Item } from 'elements/List';
import { Link } from 'elements/Text';
import { TextButton } from 'elements/Input';
import { UserContext } from 'contexts/UserContext';
import routes, { queries } from 'routes';

const Directory = () => {
  const { directoryList } = useContext(UserContext);
  const [ isEditingDirectory, setIsEditingDirectory ] = useState(false);

  return isEditingDirectory ? (
    <DirectoryInput
      onCancel={() => setIsEditingDirectory(false)}
      onConfirm={() => setIsEditingDirectory(false)}
    />
  ) : (
    <List>
      <Item>
        {directoryList.length ? (
          <>
            Directory (
              <TextButton onClick={() => setIsEditingDirectory(true)}>
                 Edit
              </TextButton>
            ):
          </>
        ) : (
          <TextButton onClick={() => setIsEditingDirectory(true)}>
             Add Directory...
          </TextButton>
        )}
      </Item>
      {!!directoryList.length && directoryList.map(url => (
        <Item key={url}>
          <Link to={`${routes.root}${routes.games.root}${queries.root}${queries.source(url)}`}>{url}</Link>
        </Item>
      ))}
    </List>
  )
}

export default Directory;
